import { AttachmentField } from "@/pages/requests/components/attachments/types";
import { Document } from "@/services/api";

export const DEFAUTL_ATTACHMENT_FIELDS: Document[] = [
  {
    IsMandatory: true,
    DocNameEn: AttachmentField.License,
    TemplatePath: "",
    Format: "",
    FileBase64: "",
    FileName: "",
    TemplateTitle: null,
    DocTypeId: 1,
  },
  {
    IsMandatory: true,
    DocNameEn: AttachmentField.Person,
    TemplatePath: "",
    Format: "",
    FileBase64: "",
    FileName: "",
    TemplateTitle: null,
    DocTypeId: 1,
  },
  {
    IsMandatory: true,
    DocNameEn: AttachmentField.Vehicle,
    TemplatePath: "",
    Format: "",
    FileBase64: "",
    FileName: "",
    TemplateTitle: null,
    DocTypeId: 1,
  },
  {
    IsMandatory: true,
    DocNameEn: AttachmentField.Passport,
    TemplatePath: "",
    Format: "",
    FileBase64: "",
    FileName: "",
    TemplateTitle: null,
    DocTypeId: 1,
  },
  {
    IsMandatory: true,
    DocNameEn: AttachmentField.Other,
    TemplatePath: "",
    Format: "",
    FileBase64: "",
    FileName: "",
    TemplateTitle: null,
    DocTypeId: 1,
  },
];

export enum ApplicationField {
  Application = "Select application",
}
